class APeopleLoadMore extends HTMLElement {
  constructor() {
    super();

    this.pageUrls = JSON.parse(this.getAttribute('data-page-urls') || '[]');
    this.totalPages = this.pageUrls.length;
    this.currentPageIndex = 0;
    this.cache = {};
    this.loading = false;

    this.loadMoreButton = this.querySelector('[data-load-more]');
  }

  connectedCallback() {
    if (this.totalPages === 0) return;

    this.loadMoreButton?.addEventListener('click', () => this.handleLoadMore());
    this.preloadNextPage();
  }

  toggleLoader(show) {
    if (!this.loadMoreButton) return;
    this.loadMoreButton.classList.toggle('loading', show);
    const spinner = this.loadMoreButton.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.toggle('hidden', !show);
    }
  }

  async fetchPage(url) {
    if (this.cache[url]) {
      return this.cache[url].map((node) => node.cloneNode(true));
    }

    const response = await fetch(url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sections = this.getContentSections(doc);

    this.cache[url] = sections.map((node) => node.cloneNode(true));
    return sections;
  }

  getContentSections(doc) {
    const main = doc.querySelector('main');
    if (!main) return [];
    const allSections = main.querySelectorAll('.shopify-section');
    return Array.from(allSections).filter((section) => {
      if (section.querySelector('nav-blog')) return false;
      if (section.querySelector('a-people-load-more')) return false;
      if (section.querySelector('.antonioli-breadcrumbs')) return false;
      return true;
    });
  }

  async handleLoadMore() {
    if (this.currentPageIndex >= this.totalPages || this.loading) return;

    this.loading = true;
    this.toggleLoader(true);

    try {
      const url = this.pageUrls[this.currentPageIndex];
      const sections = await this.fetchPage(url);

      const loadMoreWrapper = this.closest('.shopify-section');
      sections.forEach((section) => {
        loadMoreWrapper.parentNode.insertBefore(section, loadMoreWrapper);
      });

      this.currentPageIndex++;
      this.updateButton();
      this.preloadNextPage();
    } catch (err) {
      console.error('Error loading more:', err);
    } finally {
      this.loading = false;
      this.toggleLoader(false);
    }
  }

  updateButton() {
    if (this.currentPageIndex >= this.totalPages) {
      this.loadMoreButton?.classList.add('tw-hidden');
    }
  }

  async preloadNextPage() {
    const nextIndex = this.currentPageIndex;
    if (nextIndex < this.totalPages && !this.cache[this.pageUrls[nextIndex]]) {
      this.fetchPage(this.pageUrls[nextIndex]).catch((err) => {
        console.error('Error preloading next page:', err);
      });
    }
  }
}

customElements.define('a-people-load-more', APeopleLoadMore);
